import React from "react";
import AdditionalManagedVolumeUnitTermsTable from "./AdditionalManagedVolumeUnitTermsTable";
import SettlementConsiderationTermsTable from "./SettlementConsiderationTermsTable";
import IntroductionPaymentTermsTable from "./IntroductionPaymentTermsTable";

const InitialScheduleTermsDetails = ({ dealerId }) => (
  <React.Fragment>
    <AdditionalManagedVolumeUnitTermsTable dealerId={dealerId} />
    <SettlementConsiderationTermsTable dealerId={dealerId} />
    <IntroductionPaymentTermsTable dealerId={dealerId} />
  </React.Fragment>
);

export default InitialScheduleTermsDetails;
